import { useEffect, useState } from "react";

const useAppLoadedHook = () => {
    const [isLoaded, setIsLoaded] = useState(document.readyState === "complete");

    useEffect(() => {
        const handleReadyStateChange = () => {
            if (document.readyState === "complete") {
                setIsLoaded(true);
            }
        };

        document.addEventListener("readystatechange", handleReadyStateChange);

        return () => {
            document.removeEventListener("readystatechange", handleReadyStateChange);
        };
    }, []);

    return isLoaded;
};

export default useAppLoadedHook;
